export const environment = {
  production: false,
  urls: {
    apiUrl: 'https://offers.rts-tender.ru/api/v1/',
    dictionaryApiUrl: 'https://offers.rts-tender.ru/api-gateway/dictionary/api/v1/',
    dadataProxyApiUrl: 'https://offers.rts-tender.ru/api-gateway/dadata/',
    rootUrl: 'https://offers.rts-tender.ru/',
    configurationUrl: 'https://offers.rts-tender.ru/api/v1/Configuration',
    errorLogUrl: 'https://offers.rts-tender.ru/api/v1/client/log/error',
    fcsBaseUrl: 'https://app.rts-tender.ru',
  },
};
